import {
  CandidateFile,
  CandidateVerificationHistory,
  Company,
  User,
  CandidateDetails,
  CandidateVerificationMode,
  CandidateVerificationResult,
  CandidateVerificationStatus,
  CandidateDetailsForm,
  CandidateProcedure,
  Pagination,
  ServiceTypeForEmploymentLegalisation,
  ServiceTypeOptional,
} from '@interfaces';

export interface CandidateVerification {
  id: string;
  companyId: string;
  company?: Partial<Company> | null;
  candidateDetails?: CandidateDetails;
  candidateDetailsId: string;
  candidateDetailsForm?: CandidateDetailsForm | null;
  mode: CandidateVerificationMode;
  files?: CandidateFile[];
  history?: CandidateVerificationHistory[];
  status: CandidateVerificationStatus;
  result: CandidateVerificationResult | null;
  commentsAndNotesForEmployer?: string | null;
  stayDocumentType?: string | null;
  stayDocumentValidityDate?: string | null;
  stayDocumentIndefinitely?: boolean;
  employmentDocumentType?: string | null;
  employmentDocumentValidityDate?: string | null;
  employmentDocumentIndefinitely?: boolean;
  candidateCitizenship?: string | null;
  proceduresBeforeHire?: CandidateProcedure[];
  estimatedDateToCompleteProcedures?: Date | null;
  createdAt: Date;
  createdBy?: User;
  createdById: string;
  updatedAt: Date;
  updatedBy?: User;
  updatedById: string | null;
  cannotBeEmployedJustification: string | null;
}

export interface NewCandidateVerificationOpts {
  email: string;
  telephoneNumber: string;
  firstName: string;
  lastName: string;
  positionName: string;
  languageId: string;
  companyId: string;
}

export interface SearchCandidateVerificationsOpts extends Pagination {
  companiesIds?: string[] | null;
  query?: string | null;
  statuses?: CandidateVerificationStatus[] | null;
}

export interface CandidateVerificationColumnOption {
  key: string;
  labelKey: string;
  alwaysVisible: boolean;
}

// You can provide one or all fields
// If you set some field to 'null' its value WILL NOT BE UPDATED IN THE DB!
export interface UpdateCandidateVerificationDetailsOpts {
  email?: string | null;
  telephoneNumber?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  positionName?: string | null;
  languageId?: string | null;
  companyId?: string | null;
}

export enum CandidateVerificationEmployerDecision {
  ACCEPT = 'ACCEPT',
  REJECT = 'REJECT',
}

export interface UpdateCandidateVerificationDecisionOpts {
  decision: CandidateVerificationEmployerDecision;
}

export interface UpdateCandidateVerificationStatusOpts {
  newStatus: CandidateVerificationStatus;
  // Required (and must be strictly in the future) only when moving to a form-requesting status.
  validUntil?: string | null;
  // Required only when moving to the supplementary form-requesting status.
  suplementaryFormComment?: string | null;
}

export interface SaveCandidateVerificationProcedureOpts {
  type: ServiceTypeForEmploymentLegalisation | ServiceTypeOptional;
  estimatedCompletionDate?: string | null;
}

export interface SaveCandidateVerificationResultOpts {
  result: CandidateVerificationResult;
  stayDocumentType?: string | null;
  stayDocumentValidityDate?: string | null;
  stayDocumentIndefinitely?: boolean;
  employmentDocumentType?: string | null;
  employmentDocumentValidityDate?: string | null;
  employmentDocumentIndefinitely?: boolean;
  candidateCitizenship?: string | null;
  commentsAndNotesForEmployer?: string | null;
  proceduresBeforeHire?: SaveCandidateVerificationProcedureOpts[];
  estimatedDateToCompleteProcedures?: string | null;
  cannotBeEmployedJustification?: string | null;
}

export interface RequestCandidateVerificationSupplementaryInfoOpts {
  suplementaryFormComment: string;
}
